import * as styles from "./SectionTitleBody.module.scss";

import React from "react";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface SectionQuickLinksProps {
	title: string;
	body: string;
	withBreak?: boolean;
}

export const SectionTitleBody: React.FC<SectionQuickLinksProps> = ({
	title,
	body,
}) => {
	return (
		<WrappedSection sectionName="SectionTitleBody">
			<div className={styles.titlebodyinner}>
				<div className={styles.textarea}>
					<h2>{title}</h2>
					<p>{body}</p>
				</div>
			</div>
		</WrappedSection>
	);
};

export default SectionTitleBody;
